import {FormField, Input, InputField, VStack} from "@hosttools/frontend/components";
import {buildChannel} from "@hosttools/frontend/models/channel";
import type React from "react";
import {memo, useCallback, useMemo} from "react";

import type {CredentialsType, Errors} from "@/admin/components/ModalAddAccount/types";

type Props = {
    credentials: CredentialsType;
    errors?: Errors;
    onChangeCredentials: (field: "username" | "password", value: string) => void;
};

const HomeAwayCredential: React.FC<Props> = ({errors, credentials, onChangeCredentials}) => {
    const {label} = useMemo(() => buildChannel("HomeAway"), []);

    const handleChangeUsername = useCallback(
        (text: string) => {
            onChangeCredentials("username", text);
        },
        [onChangeCredentials]
    );

    const handleChangePassword = useCallback(
        (text: string) => {
            onChangeCredentials("password", text);
        },
        [onChangeCredentials]
    );

    return (
        <VStack space="lg">
            <FormField
                error={errors?.username}
                label={`${label} Email`}
                tooltip={`Enter the email address you use to login to your ${label} account.`}
            >
                <Input isRequired>
                    <InputField
                        autoComplete="off"
                        id="username"
                        name="username"
                        placeholder={`${label} Email...`}
                        type="text"
                        value={credentials.username}
                        onChangeText={handleChangeUsername}
                    />
                </Input>
            </FormField>
            <FormField
                error={errors?.password}
                label={`${label} Password`}
                tooltip={`Enter your ${label} password.`}
            >
                <Input isRequired>
                    <InputField
                        autoComplete="new-password"
                        id="password"
                        name="password"
                        placeholder={`${label} Password...`}
                        type="password"
                        value={credentials.password}
                        onChangeText={handleChangePassword}
                    />
                </Input>
            </FormField>
        </VStack>
    );
};

export default memo(HomeAwayCredential);
